import React from "react";

import {
  PhoneIcon,
  MailIcon,
  BriefcaseIcon,
  MapPinIcon,
} from "../../../../assets/ui/icons";
import { DetailCard } from "./DetailCard";
import { ADDRESS_ROWS, addressRowValues, addressStatus } from "./addressFields";

/* One address, as the design's navy card. */
const ROW_ICONS = {
  telephone: PhoneIcon,
  email: MailIcon,
  working_hours: BriefcaseIcon,
  address: MapPinIcon,
};

export const AddressCard = ({ record, onEdit, className = "" }) => {
  const values = addressRowValues(record);

  return (
    <DetailCard
      className={className}
      status={addressStatus(record)}
      rows={ADDRESS_ROWS.map((row) => ({
        key: row.key,
        label: row.label,
        icon: ROW_ICONS[row.key],
        value: values[row.key],
      }))}
      onEdit={onEdit}
    />
  );
};

export default AddressCard;
